import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons/faCalendar";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons/faBoxOpen";
import { useHistory } from "react-router-dom";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useHasPartsTab } from "../hooks/useUiv";
import { BOTTOM_NAV_HEIGHT } from "./bottomNav.utils";

const useStyles = makeStyles((theme) => ({
  root: {
    height: BOTTOM_NAV_HEIGHT,
  },
}));

/**
 * Lifts the active tab's icon. Wraps our own icon rather than MUI's internals, so
 * `transform` can't disturb BottomNavigation's sizing or child indexing.
 *
 * `icon` is `any` for the same reason every call site already cast it: two copies of
 * fontawesome-common-types resolve in node_modules and their IconDefinition types
 * don't match.
 */
const NavIcon = ({ icon, active, still }: { icon: any; active: boolean; still: boolean }) => (
  <span
    style={{
      display: "inline-flex",
      transform: active ? "translateY(-2px) scale(1.15)" : "none",
      transition: still ? undefined : "transform 220ms cubic-bezier(0.2, 0.8, 0.3, 1)",
    }}
  >
    <FontAwesomeIcon icon={icon as any} />
  </span>
);

/** The tab a page belongs to: a job is usually opened from the Schedule, so job pages light Schedule up. */
export const navValueFor = (pathname: string) => (pathname.startsWith("/jobs/") ? "/" : pathname);

export const BottomNav = () => {
  const classes = useStyles();
  const {
    location: { pathname },
    push,
  } = useHistory();
  const [value, setValue] = useState(navValueFor(pathname));
  const hasPartsTab = useHasPartsTab();
  const still = useMediaQuery("(prefers-reduced-motion: reduce)");
  return (
    <BottomNavigation
      className={classes.root}
      value={value}
      onChange={async (event, newValue) => {
        setValue(newValue);
        await push(newValue);
      }}
      showLabels
    >
      {/*
        Built as a filtered array rather than inline `{cond && <Action/>}` — a `false`
        child throws off BottomNavigation's child indexing.
      */}
      {[
        <BottomNavigationAction
          key="schedule"
          label="Schedule"
          icon={<NavIcon icon={faCalendar} active={value === "/"} still={still} />}
          value={"/"}
        />,
        hasPartsTab ? (
          <BottomNavigationAction
            key="parts"
            label="Parts"
            icon={<NavIcon icon={faBoxOpen} active={value === "/parts"} still={still} />}
            value={"/parts"}
          />
        ) : null,
      ].filter(Boolean)}
    </BottomNavigation>
  );
};
